import { assert } from '../../lib/assert-sidecar'
import { common } from '../../main/common-sidecar'
import { EVoyageCrewType, IVoyageCrew } from './voyageCrew'
import { voyageCrew } from './voyageCrew-sidecar'
import { voyageParticles } from './voyageParticles-sidecar'
import { voyageSystems } from './voyageSystems-sidecar'
import { voyageTilemap } from './voyageTilemap-sidecar'

export function crewUpdate(obj: IVoyageCrew) {
  let ds = common.getUpdateDeltaScaled()
  let d = obj.crewState
  assert.notNil(d)

  d.useSystemTimer += ds

  let useSystemTime = 0.5
  if (d.useSystemTimer > useSystemTime) {
    d.useSystemTimer -= useSystemTime

    if (voyageSystems.testNoPower(obj)) {
      return
    }

    let tHere = voyageTilemap.getSafeIJ(obj)
    if (tHere) {
      let sys = voyageTilemap.getSystemSafe(
        ('' + tHere.text3).replace('pad', 'med'),
      )
      if (sys) {
        let dr = voyageCrew.getAt(sys, (c) => c.type === EVoyageCrewType.Crew)
        // let toHeal = voyageCrew.getAt(
        //   sys,
        //   (c) => c.type === EVoyageCrewType.Crew,
        // )
        if (dr && !dr.isDying) {
          // voyageParticles.createMultiple('heal', sys.x, sys.y, 1)

          let toHeal = obj
          if (toHeal && !toHeal.isDying) {
            let healRate = 10
            toHeal.hitpoints += useSystemTime * healRate
            if (toHeal.hitpoints > 125) {
              toHeal.hitpoints = 125
            }
          }
        }
      }
    }
  }
}
